<div class="row">
    <div class="col">
        <div class="row">
            <div class="col-auto">
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control" placeholder="지역이름"
                        [(ngModel)]="searchValueConf">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary"
                            (click)="clickSearchGeofenceConf()">
                            <i class="fas fa-search"></i>
                            <span class="ml-1">
                                지역검색
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col">
                <div class="table-responsive">
                    <table class="table table-sm table-hover align-items-center mb-0">
                        <thead class="">
                            <tr>
                                <th>
                                    설정이름
                                </th>
                                <th>
                                    설정타입
                                </th>
                                <th>
                                    useYn
                                </th>
                                <th>
                                    차량목록
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="!listGeofenceConf">
                                <tr>
                                    <td colspan="4">
                                        표시 할 항목이 없습니다
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-container *ngIf="listGeofenceConf">
                                <tr *ngFor="let item of listGeofenceConf;index as idx;"
                                    [class.table-primary]="item.geoFenceId === selectedGeoFenceConf?.geoFenceId">
                                    <td>
                                        <span>{{item.geoFenceNm}}</span>
                                    </td>
                                    <td [ngSwitch]="item.shapeType">
                                        <span *ngSwitchCase="'C'">원형</span>
                                        <span *ngSwitchCase="'R'">사각형</span>
                                        <span *ngSwitchDefault>다각형</span>
                                    </td>
                                    <td>
                                        <span>{{item.useYn}}</span>
                                    </td>
                                    <td>
                                        <button type="button" class="btn btn-sm btn-outline-secondary"
                                            (click)="clickFindAllCar(item)">
                                            <i class="fas fa-search"></i>
                                            <span class="ml-1">
                                                차량목록
                                            </span>
                                        </button>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>

                <div class="mt-3">
                    <list-paging
                        [inputPagingInfo]="pagingInfoConf"
                        (callbackClickPageNumber)="callbackClickPageNumberConf($event)"
                        (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPageConf($event)"></list-paging>
                </div>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="row">
            <div class="col-auto">
                <div class="row">
                    <ng-container *ngIf="selectedGeoFenceConf">
                        <div class="col-auto d-flex align-items-center">
                            <div class="h5 mb-0">
                                {{selectedGeoFenceConf.geoFenceNm}}
                            </div>
                        </div>
                    </ng-container>
                    <div class="col">
                        <button type="button" class="btn btn-sm btn-outline-secondary"
                            (click)="clickOpenModalCarList(DtgActionType.read)">
                            <i class="fas fa-search"></i>
                            <span class="ml-1">
                                차량추가
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col">
                <div class="table-responsive">
                    <table class="table table-sm table-hover align-items-center mb-0">
                        <thead class="">
                            <tr>
                                <th>
                                    단말번호
                                </th>
                                <th>
                                    차량번호
                                </th>
                                <th>
                                    편집
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="!listGeofenceCar">
                                <tr>
                                    <td colspan="3">
                                        표시 할 항목이 없습니다
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-container *ngIf="listGeofenceCar">
                                <tr *ngFor="let item of listGeofenceCar;index as idx;">
                                    <td>
                                        <span>{{item.dtgUnitId}}</span>
                                    </td>
                                    <td>
                                        <span>{{item.dtgCarNo}}</span>
                                    </td>
                                    <td>
                                        <button type="button" class="btn btn-sm btn-outline-secondary"
                                            (click)="clickDeleteCar(item)">
                                            <i class="fas fa-ban"></i>
                                            <span class="ml-1">
                                                차량제거
                                            </span>
                                        </button>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
                <div class="mt-3">
                    <list-paging
                        [inputPagingInfo]="pagingInfoCar"
                        (callbackClickPageNumber)="callbackClickPageNumberCar($event)"
                        (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPageCar($event)"></list-paging>
                </div>
            </div>
        </div>
    </div>
</div>